import { create, destroy } from '@dojo/framework/core/vdom';
import has from '@dojo/framework/core/has';
import { lccstate, userstate, keymap, pathmap } from '..';
const factory = create({ destroy, lccstate, userstate });
export const recommended = factory(({ middleware: { destroy, lccstate, userstate } }) => {
    const { get, path } = userstate;
    const handles = [];
    destroy(() => {
        let handle;
        while ((handle = handles.pop())) {
            handle();
        }
    });
    const api = {
        tracked: {
            recommended: [],
            allcompleted: [],
            tgfkeys: [],
            assessment: {}
        },
        setup() {
            this.recalculate();
            const store = userstate.getStore();
            const { path } = store;
            const handle = store.onChange([path('status'), path('assessment')], () => {
                this.recalculate();
            });
            handles.push(() => handle.remove());
        },
        recalculate() {
            const assessment = (this.tracked.assessment = get(path('assessment')));
            const status = get(path('status'));
            if (has('use-ml-study-plan')) {
                this.tracked.tgfkeys = Object.keys(assessment).filter((k) => assessment[k].data.order !== undefined && assessment[k].data.questioncount === undefined);
            }
            else {
                this.tracked.tgfkeys = Object.keys(assessment).filter((k) => assessment[k].parent !== null);
            }
            this.tracked.allcompleted = [];
            const { tgfkeys, allcompleted } = this.tracked;
            this.tracked.recommended = tgfkeys
                .map((k) => {
                const [topichead, topicset] = [assessment[k].parent, k];
                const basepath = `/explore/${topichead}/${topicset}`;
                const tskey = keymap.get(topicset);
                const title = tskey ? tskey.title : '';
                const { data, parent } = status[topicset];
                const completed = data.percent >= 0.8 && data.complete === data.total;
                const isactive = !completed && (data.complete > 0 || data.percent > 0);
                const pretest = assessment[parent].data.percent;
                const isreadingstarted = data.complete > 0;
                const isreadingcompleted = data.complete === data.total;
                const isquizcompleted = data.percent > 0;
                const recommendedorder = assessment[topicset].data.order || 0;
                allcompleted.push(completed);
                const { percent } = assessment[k].data;
                return {
                    topichead,
                    topicset,
                    title,
                    basepath,
                    percent,
                    isactive,
                    completed,
                    pretest,
                    isreadingstarted,
                    isreadingcompleted,
                    isquizcompleted,
                    recommendedorder
                };
            })
                .sort((l, r) => {
                if (has('use-ml-study-plan')) {
                    if (l.recommendedorder !== undefined && r.recommendedorder !== undefined) {
                        return l.recommendedorder - r.recommendedorder;
                    }
                    else {
                        return 0;
                    }
                }
                else {
                    if (l.percent !== r.percent) {
                        return l.percent - r.percent;
                    }
                    return l.topicset > r.topicset ? 1 : -1;
                }
            });
        },
        hasAssessment() {
            return this.tracked.tgfkeys.length > 0 && this.assessResults().some((v) => v.isTestCompleted);
        },
        assessmentsComplete() {
            return this.tracked.tgfkeys.length > 0 && this.assessResults().every((v) => v.isTestCompleted);
        },
        allcomplete() {
            const { allcompleted } = this.tracked;
            return allcompleted.length > 0 && allcompleted.every((v) => v);
        },
        topicsets(noCompleted) {
            const { recommended } = this.tracked;
            const rlist = noCompleted ? recommended.filter((item) => !item.completed) : recommended;
            const topic = {
                attributes: { key: `content-view` },
                children: []
            };
            const topicsets = rlist.map((recitem) => {
                const { topicset } = recitem;
                const { path } = keymap.get(topicset);
                const { topic } = pathmap.get(path);
                return { ...topic };
            });
            topic.children = topicsets.flat();
            return topic;
        },
        assessResults() {
            const roots = lccstate.get(lccstate.path('ditaroots'));
            const { assessment } = this.tracked;
            return roots.map((root) => {
                const { title = root, id = root } = keymap.get(root) || {};
                const assessmentTopic = assessment[id] ? assessment[id] : assessment[root];
                const { percent = 0, pointscorrect = 0, pointsincorrect = 0 } = assessmentTopic.data;
                const isTestCompleted = percent > 0 || pointscorrect > 0 || pointsincorrect > 0;
                return {
                    topichead: root,
                    title,
                    percent,
                    isTestCompleted
                };
            });
        },
        firstIncomplete() {
            const { recommended } = this.tracked;
            const incomplete = recommended.filter((item) => !item.completed);
            if (incomplete.length > 0) {
                return incomplete[0].topicset;
            }
            return null;
        }
    };
    api.setup();
    return api;
});
